import { __extends } from "tslib";
import { AbstractCanvas } from '@antv/g-base';
import { getShape } from './util/hit';
import * as Shape from './shape';
import Group from './group';
import { each, getPixelRatio, requestAnimationFrame, clearAnimationFrame } from './util/util';
import { applyAttrsToContext, drawChildren, getMergedRegion, mergeView, checkRefresh, clearChanged } from './util/draw';
var Canvas = /** @class */ (function (_super) {
    __extends(Canvas, _super);
    function Canvas() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Canvas.prototype.getDefaultCfg = function () {
        var cfg = _super.prototype.getDefaultCfg.call(this);
        // è®¾ç½®æ¸²æå¼æä¸º canvasï¼åªè¯»å±æ§
        cfg['renderer'] = 'canvas';
        // æ¯å¦èªå¨ç»å¶ï¼ä¸éè¦ç¨æ·è°ç¨ draw æ¹æ³
        cfg['autoDraw'] = true;
        // æ¯å¦åè®¸å±é¨å·æ°å¾è¡¨
        cfg['localRefresh'] = true;
        cfg['refreshElements'] = [];
        // æ¯å¦å¨è§å¾åèªå¨è£åª
        cfg['clipView'] = true;
        // æ¯å¦ä½¿ç¨å¿«éæ¾åçæ¹æ¡ï¼é»è®¤ä¸º falseï¼ä¸å±å¯ä»¥æå¼
        cfg['quickHit'] = false;
        return cfg;
    };
    /**
     * ä¸äºæ¹æ³è°ç¨ä¼å¼èµ·ç»å¸åå
     * @param {ChangeType} changeType æ¹åçç±»å
     */
    Canvas.prototype.onCanvasChange = function (changeType) {
        /**
         * è§¦åç»å¸æ´æ°çä¸ç§ changeType
         * 1. attr: ä¿®æ¹ç»å¸çç»å¾å±æ§
         * 2. sort: ç»å¸æåºï¼å¾å½¢çå±æ¬¡ä¼åçåå
         * 3. changeSize: æ¹åç»å¸å¤§å°
         */
        if (changeType === 'attr' || changeType === 'sort' || changeType === 'changeSize') {
            this.set('refreshElements', [this]);
            this.draw();
        }
    };
    Canvas.prototype.getShapeBase = function () {
        return Shape;
    };
    Canvas.prototype.getGroupBase = function () {
        return Group;
    };
    /**
     * è·åå±å¹åç´ æ¯
     */
    Canvas.prototype.getPixelRatio = function () {
        var pixelRatio = this.get('pixelRatio') || getPixelRatio();
        // ä¸è¶³ 1 çå 1ï¼è¶åº 1 çåæ´
        return pixelRatio >= 1 ? Math.ceil(pixelRatio) : 1;
    };
    Canvas.prototype.getViewRange = function () {
        return {
            minX: 0,
            minY: 0,
            maxX: this.cfg.width,
            maxY: this.cfg.height,
        };
    };
    // å¤ååºç±»çæ¹æ³çææ ç­¾
    Canvas.prototype.createDom = function () {
        var element = document.createElement('canvas');
        var context = element.getContext('2d');
        // ç¼å­ context å¯¹è±¡
        this.set('context', context);
        return element;
    };
    Canvas.prototype.setDOMSize = function (width, height) {
        _super.prototype.setDOMSize.call(this, width, height);
        var context = this.get('context');
        var el = this.get('el');
        var pixelRatio = this.getPixelRatio();
        el.width = pixelRatio * width;
        el.height = pixelRatio * height;
        // è®¾ç½® canvas åç´ çå®½åº¦åé«åº¦ï¼ä¼éç½®ç¼©æ¾ï¼å æ­¤ context.scale éè¦å¨æ¯æ¬¡è®¾ç½®å®½ãé«åè°ç¨
        if (pixelRatio > 1) {
            context.scale(pixelRatio, pixelRatio);
        }
    };
    // å¤ååºç±»æ¹æ³
    Canvas.prototype.clear = function () {
        _super.prototype.clear.call(this);
        this._clearFrame(); // éè¦æ¸çæå»¶è¿ç»å¶çå¸§
        var context = this.get('context');
        var element = this.get('el');
        context.clearRect(0, 0, element.width, element.height);
    };
    Canvas.prototype.getShape = function (x, y) {
        var shape;
        if (this.get('quickHit')) {
            shape = getShape(this, x, y);
        }
        else {
            shape = _super.prototype.getShape.call(this, x, y, null);
        }
        return shape;
    };
    // å¯¹ç»å¶åºåè¾¹ç¼åæ´ï¼é¿åæµ®ç¹æ°é®é¢
    Canvas.prototype._getRefreshRegion = function () {
        var elements = this.get('refreshElements');
        var viewRegion = this.getViewRange();
        var region;
        // å¦ææ¯å½åç»å¸æ´ä½åçäºååï¼åç´æ¥éç»æ´ä¸ªç»å¸
        if (elements.length && elements[0] === this) {
            region = viewRegion;
        }
        else {
            region = getMergedRegion(elements);
            if (region) {
                region.minX = Math.floor(region.minX);
                region.minY = Math.floor(region.minY);
                region.maxX = Math.ceil(region.maxX);
                region.maxY = Math.ceil(region.maxY);
                region.maxY += 1; // å¨å¾å¤ç¯å¢ä¸å­ä½çé«ä½ä¼ä¸ä¸è´ï¼éå ä¸åç´ ï¼é¿åæ®å½±
                var clipView = this.get('clipView');
                // èªå¨è£åªä¸å¨ view åçåºå
                if (clipView) {
                    region = mergeView(region, viewRegion);
                }
            }
        }
        return region;
    };
    /**
     * å·æ°å¾å½¢åç´ ï¼è¿éä»ä»æ¯æ¾å¥éåï¼ä¸æ¬¡ç»å¶æ¶è¿è¡ç»å¶
     * @param {IElement} element å¾å½¢åç´ 
     */
    Canvas.prototype.refreshElement = function (element) {
        var refreshElements = this.get('refreshElements');
        refreshElements.push(element);
        // if (this.get('autoDraw')) {
        //   this._startDraw();
        // }
    };
    // æ¸çè¿å¨è¿è¡çç»å¶
    Canvas.prototype._clearFrame = function () {
        var drawFrame = this.get('drawFrame');
        if (drawFrame) {
            // å¦æå¨é¨æ¸²ææ¶ï¼å­å¨å±é¨æ¸²æï¼åæå¼æå±é¨æ¸²æ
            clearAnimationFrame(drawFrame);
            this.set('drawFrame', null);
            this.set('refreshElements', []);
        }
    };
    // æå·¥è°ç¨ç»å¶æ¥å£
    Canvas.prototype.draw = function () {
        var drawFrame = this.get('drawFrame');
        if (this.get('autoDraw') && drawFrame) {
            return;
        }
        this._startDraw();
    };
    // ç»å¶ææå¾å½¢
    Canvas.prototype._drawAll = function () {
        var context = this.get('context');
        var element = this.get('el');
        var children = this.getChildren();
        context.clearRect(0, 0, element.width, element.height);
        applyAttrsToContext(context, this);
        drawChildren(context, children);
        // å¯¹äº https://github.com/antvis/g/issues/422 çåºæ¯ï¼å¨å±æ¸²æçæ¨¡å¼ä¸ä¹ä¼è®°å½æ´æ°çåç´ éåï¼å æ­¤å¨å±æ¸²æå®åä¹éè¦ç½®ç©º
        this.set('refreshElements', []);
    };
    // ç»å¶å±é¨
    Canvas.prototype._drawRegion = function () {
        var context = this.get('context');
        var refreshElements = this.get('refreshElements');
        var children = this.getChildren();
        var region = this._getRefreshRegion();
        // éè¦æ³¨æå¯è½æ²¡æ region çåºæ¯
        // ä¸è¬åçå¨è®¾ç½®äº localRefresh ,å¨æ²¡æå¾å½¢åçååçæåµä¸ï¼ç¨æ·è°ç¨äº draw
        if (region) {
            // æ¸çæå®åºå
            context.clearRect(region.minX, region.minY, region.maxX - region.minX, region.maxY - region.minY);
            // ä¿å­ä¸ä¸æï¼è®¾ç½® clip
            context.save();
            context.beginPath();
            context.rect(region.minX, region.minY, region.maxX - region.minX, region.maxY - region.minY);
            context.clip();
            applyAttrsToContext(context, this);
            // ç¡®è®¤æ´æ°çåç´ ï¼è¿ä¸ªä¼åå¯ä»¥æå 10 åå·¦å³çæ§è½ï¼10W ä¸ªå¸¦æ group çèç¹ï¼å±é¨æ¸²æä¼ä» 90ms ä¸éå° 5-6 ms
            checkRefresh(this, children, region);
            // ç»å¶å­åç´ 
            drawChildren(context, children, region);
            context.restore();
        }
        else if (refreshElements.length) {
            // é²æ­¢åçæ¹åç elements æ²¡æ region çåºæ¯ï¼è¿ä¼åçå¨å¤ä¸ªæåµä¸
            // 1. ç©ºç group
            // 2. ææ elements æ²¡æå¨ç»å¾åºå
            // 3. group ä¸é¢ç elements éèæ
            // å¦æä¸è¿è¡æ¸ç hasChanged çç¶æä¼ä¸æ­£ç¡®
            clearChanged(refreshElements);
        }
        each(refreshElements, function (element) {
            if (element.get('hasChanged')) {
                // å¨è§çªå¤ç Group åç´ ä¼å å¥å°æ´æ°éåéï¼ä½å®éå´æ²¡ææ§è¡ draw() é»è¾ï¼ä¹å°±æ²¡ææ¸é¤ hasChanged æ è®°
                // å³å·²ç»éç»å®ãä½ hasChanged æ è®°æ²¡ææ¸é¤çåç´ ï¼éè¦ç»ä¸æ¸é¤æãä¸»è¦æ¯ Group å­å¨é®é¢ï¼å·ä½åå å¾ææ¥
                element.set('hasChanged', false);
            }
        });
        this.set('refreshElements', []);
    };
    // è§¦åç»å¶
    Canvas.prototype._startDraw = function () {
        var _this = this;
        var drawFrame = this.get('drawFrame');
        if (!drawFrame) {
            drawFrame = requestAnimationFrame(function () {
                if (_this.get('localRefresh')) {
                    _this._drawRegion();
                }
                else {
                    _this._drawAll();
                }
                _this.set('drawFrame', null);
            });
            this.set('drawFrame', drawFrame);
        }
    };
    Canvas.prototype.skipDraw = function () { };
    Canvas.prototype.removeDom = function () {
        var el = this.get('el');
        // éè¦æ¸ç canvas ç»å¸åå®¹ï¼å¦åiosä¸ åå»ºçcanvasåå¾æªåæ¶ï¼å¯¼è´Total canvas memory use exceedsé®é¢
        // ç¸å³é®é¢åè¡¨
        // https://stackoverflow.com/questions/52532614/total-canvas-memory-use-exceeds-the-maximum-limit-safari-12
        // https://github.com/openlayers/openlayers/issues/9291
        el.width = 0;
        el.height = 0;
        el.parentNode.removeChild(el);
    };
    return Canvas;
}(AbstractCanvas));
export default Canvas;
//# sourceMappingURL=canvas.js.map